import type { Directive } from 'vue'
import sanitizeHtml from 'sanitize-html'

export const safeHtmlDirective: Directive<HTMLElement, string> = {
  mounted(el, binding) {
    // If the value is undefined or null, default to an empty string
    let rawValue = binding.value ?? ''
    // Handle backwards compatibility for newlines
    rawValue = rawValue.replace(/\n/g, '<br>')
    el.innerHTML = sanitizeHtml(rawValue)
  },
  updated(el, binding) {
    // Only re-sanitize and update the DOM if the value actually changed
    if (binding.value !== binding.oldValue) {
      let rawValue = binding.value ?? ''
      rawValue = rawValue.replace(/\n/g, '<br>')
      el.innerHTML = sanitizeHtml(rawValue)
    }
  }
}
